var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiMagic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7L9.484 8.394C8.808 10.222 8.47 11.136 7.803 11.803C7.136 12.47 6.222 12.808 4.394 13.484L3 14L4.394 14.516C6.222 15.192 7.136 15.531 7.803 16.197C8.47 16.863 8.808 17.778 9.484 19.606L10 21L10.516 19.606C11.192 17.778 11.531 16.864 12.197 16.197C12.863 15.53 13.778 15.192 15.606 14.516L17 14L15.606 13.484C13.778 12.808 12.864 12.47 12.197 11.803C11.53 11.136 11.192 10.222 10.516 8.394L10 7ZM18 3L17.779 3.597C17.489 4.381 17.344 4.773 17.059 5.058C16.773 5.344 16.381 5.489 15.597 5.778L15 6L15.598 6.221C16.381 6.511 16.773 6.656 17.058 6.941C17.344 7.227 17.489 7.619 17.778 8.403L18 9L18.221 8.403C18.511 7.619 18.656 7.227 18.941 6.942C19.227 6.656 19.619 6.511 20.403 6.222L21 6L20.402 5.779C19.619 5.489 19.227 5.344 18.942 5.059C18.656 4.773 18.511 4.381 18.222 3.597L18 3Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMagic);
export default __webpack_public_path__ + "static/media/AI-magic.2bc5f3ae3871f6553a7d193e249e87b8.svg";
export { ForwardRef as ReactComponent };